module.exports = __webpack_public_path__ + "static/media/28.db1c49fc.wav";